import { useState } from "react";

/** Modal de confirmação customizado (sem `window.confirm` nativo). */
export function ConfirmModal({
  title,
  message,
  confirmLabel = "Confirmar",
  onConfirm,
  onClose,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div className="modal prompt-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-label={title}>
        <header className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fechar" type="button">×</button>
        </header>
        <p style={{ padding: "0 16px", margin: "8px 0 0" }}>{message}</p>
        <div className="admin-user-actions" style={{ padding: 16, justifyContent: "flex-end" }}>
          <button className="btn-reject" type="button" onClick={onClose}>Cancelar</button>
          <button
            className="btn-approve"
            type="button"
            autoFocus
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}


/**
 * Modal de entrada de texto customizado (sem `window.prompt` nativo) - par do
 * ConfirmModal pra confirmações que exigem digitar algo (ex.: e-mail da conta
 * antes de excluir).
 */
export function PromptModal({
  title,
  label,
  placeholder,
  submitLabel = "Confirmar",
  danger = false,
  onSubmit,
  onClose,
}: {
  title: string;
  label: string;
  placeholder?: string;
  submitLabel?: string;
  /** Ação destrutiva: botão de envio em vermelho. */
  danger?: boolean;
  onSubmit: (value: string) => void;
  onClose: () => void;
}) {
  const [value, setValue] = useState("");
  const submit = () => {
    onSubmit(value);
    onClose();
  };
  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div className="modal prompt-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-label={title}>
        <header className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fechar" type="button">×</button>
        </header>
        <div style={{ padding: "8px 16px 0" }}>
          <label className="field">
            <span>{label}</span>
            <input
              type="text"
              value={value}
              placeholder={placeholder}
              autoFocus
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") submit();
              }}
            />
          </label>
        </div>
        <div className="admin-user-actions" style={{ padding: 16, justifyContent: "flex-end" }}>
          <button className="btn-approve" type="button" onClick={onClose}>Cancelar</button>
          <button className={danger ? "btn-reject" : "btn-approve"} type="button" onClick={submit}>
            {submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
